export interface FlashCallAccess {
  enabled: boolean;
  featureEnabled: boolean;
  ttlSeconds: number;
}

export const FLASH_CALL_ACCESS_DISABLED: FlashCallAccess = {
  enabled: false,
  featureEnabled: false,
  ttlSeconds: null,
};

export const FLASH_CALL_CHANNEL = 'flash_call';

export const FLASH_CALL_CHANNEL_FILTER = 'FLASH_CALL';
